// extracted by mini-css-extract-plugin
export default {"container":"TopicBreadcrumbs-module__container--+jEzd","animatedBackground":"TopicBreadcrumbs-module__animatedBackground--O-B8U"};